module.exports = __webpack_public_path__ + "img/叶坪中华苏维埃共和国中央传令排旧址.f6915a16.png";